export const categories = [
    "Électricité",
    "Menuiserie",
    "Plomberie",
    "Gros œuvre",
    "Maçonnerie",
    "Peinture",
    "Plâtrerie",
    "Carrelage",
    "Chauffage",
    "Couverture",
    "Isolation",
    "Serrurerie",
    "Charpente",
    "Terrassement",
    "Cuisiniste",
    "Négoce",
  ];